import React from 'react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
    return (
        <>
            {/* ABOUT HERO SECTION */}
            <section id="about-2" className="about-section">
                <div className="bg-inner bg-lightgrey inner-page-hero division">
                    <div className="container">
                        {/* ABOUT TITLE */}
                        <div className="row justify-content-center">
                            <div className="col-md-10 col-lg-8">
                                <div className="about-2-title">
                                    {/* Title */}
                                    <h2 className="h2-xl">
                                        Empowering Global Communication Through Translation
                                    </h2>
                                    {/* Text */}
                                    <p className="p-xl">
                                        Rush Studio is your complete translation management platform,
                                        designed to streamline multilingual content creation and collaboration
                                        for teams of all sizes.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* END ABOUT TITLE */}
                        {/* ABOUT IMAGES */}
                        <div className="about-2-images">
                            <div className="row row-cols-1 row-cols-md-2">
                                {/* IMAGES-1 */}
                                <div className="col col-md-5">
                                    <img
                                        className="img-fluid"
                                        src="/images/about-1-img.jpg"
                                        alt="Translation management platform"
                                    />
                                </div>
                                {/* IMAGES-2 */}
                                <div className="col col-md-7">
                                    <img
                                        className="img-fluid"
                                        src="/images/about-2-img.jpg"
                                        alt="Collaborative translation workspace"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* END ABOUT IMAGES */}
                    </div>
                    {/* End container */}
                </div>
                {/* End bg-inner */}
            </section>
            {/* END ABOUT HERO */}

            {/* FEATURES SECTION */}
            <section id="features-4" className="wide-60 features-section division">
                <div className="container">
                    {/* SECTION TITLE */}
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xl-8">
                            <div className="section-title title-01 mb-70">
                                {/* Title */}
                                <h2 className="h2-md">Why Choose Rush Studio?</h2>
                                {/* Text */}
                                <p className="p-xl">
                                    Our platform combines powerful translation tools with seamless
                                    collaboration features to help you deliver high-quality multilingual
                                    content faster than ever before.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* FEATURES WRAPPER */}
                    <div className="fbox-4-wrapper fbox-4-wide">
                        <div className="row row-cols-1 row-cols-md-2">
                            {/* FEATURE BOX #1 */}
                            <div className="col">
                                <div className="fbox-4 pr-25 mb-40 wow fadeInUp">
                                    {/* Icon */}
                                    <div className="fbox-ico">
                                        <div className="ico-65">
                                            <span className="flaticon-translation" />
                                        </div>
                                    </div>
                                    {/* Text */}
                                    <div className="fbox-txt">
                                        {/* Title */}
                                        <h5 className="h5-md">AI-Powered Translation</h5>
                                        {/* Text */}
                                        <p className="p-lg">
                                            Leverage advanced AI and machine translation engines including
                                            DeepL, Google Translate, and OpenAI to accelerate your translation
                                            workflow with exceptional quality.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* FEATURE BOX #2 */}
                            <div className="col">
                                <div className="fbox-4 pl-25 mb-40 wow fadeInUp">
                                    {/* Icon */}
                                    <div className="fbox-ico">
                                        <div className="ico-65">
                                            <span className="flaticon-team" />
                                        </div>
                                    </div>
                                    {/* Text */}
                                    <div className="fbox-txt">
                                        {/* Title */}
                                        <h5 className="h5-md">Team Collaboration</h5>
                                        {/* Text */}
                                        <p className="p-lg">
                                            Work together seamlessly with your team. Assign tasks, track
                                            progress, and communicate in real-time to ensure consistent
                                            translations across all your projects.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* FEATURE BOX #3 */}
                            <div className="col">
                                <div className="fbox-4 pr-25 mb-40 wow fadeInUp">
                                    {/* Icon */}
                                    <div className="fbox-ico">
                                        <div className="ico-65">
                                            <span className="flaticon-cloud-computing" />
                                        </div>
                                    </div>
                                    {/* Text */}
                                    <div className="fbox-txt">
                                        {/* Title */}
                                        <h5 className="h5-md">Cloud Integration</h5>
                                        {/* Text */}
                                        <p className="p-lg">
                                            Connect with Google Drive, Dropbox, and OneDrive to import and
                                            export your files effortlessly. Keep your translations synced
                                            across all your platforms.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* FEATURE BOX #4 */}
                            <div className="col">
                                <div className="fbox-4 pl-25 mb-40 wow fadeInUp">
                                    {/* Icon */}
                                    <div className="fbox-ico">
                                        <div className="ico-65">
                                            <span className="flaticon-database" />
                                        </div>
                                    </div>
                                    {/* Text */}
                                    <div className="fbox-txt">
                                        {/* Title */}
                                        <h5 className="h5-md">Translation Memory</h5>
                                        {/* Text */}
                                        <p className="p-lg">
                                            Build your translation memory to ensure consistency and reduce
                                            costs. Reuse previously translated content and maintain your
                                            brand voice across all languages.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* FEATURE BOX #5 */}
                            <div className="col">
                                <div className="fbox-4 pr-25 mb-40 wow fadeInUp">
                                    {/* Icon */}
                                    <div className="fbox-ico">
                                        <div className="ico-65">
                                            <span className="flaticon-file-1" />
                                        </div>
                                    </div>
                                    {/* Text */}
                                    <div className="fbox-txt">
                                        {/* Title */}
                                        <h5 className="h5-md">Multiple File Formats</h5>
                                        {/* Text */}
                                        <p className="p-lg">
                                            Support for DOCX, XLSX, IDML, JSON, and more. Preserve formatting
                                            and structure while translating your documents with precision and
                                            accuracy.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* FEATURE BOX #6 */}
                            <div className="col">
                                <div className="fbox-4 pl-25 mb-40 wow fadeInUp">
                                    {/* Icon */}
                                    <div className="fbox-ico">
                                        <div className="ico-65">
                                            <span className="flaticon-analytics" />
                                        </div>
                                    </div>
                                    {/* Text */}
                                    <div className="fbox-txt">
                                        {/* Title */}
                                        <h5 className="h5-md">Analytics & Insights</h5>
                                        {/* Text */}
                                        <p className="p-lg">
                                            Track your translation progress, monitor team performance, and
                                            gain insights into your localization workflow with comprehensive
                                            analytics and reporting.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END FEATURES WRAPPER */}
                </div>
                {/* End container */}
            </section>
            {/* END FEATURES */}

            {/* DIVIDER */}
            <hr className="divider" />

            {/* STATISTICS SECTION */}
            <section id="statistic-4" className="bg-lightgrey wide-100 statistic-section division">
                <div className="container">
                    <div className="row d-flex align-items-center">
                        {/* TEXT BLOCK */}
                        <div className="col-lg-6">
                            <div className="txt-block right-column wow fadeInLeft">
                                {/* Title */}
                                <h2 className="h2-xs">
                                    Trusted by Teams Worldwide
                                </h2>
                                {/* Text */}
                                <p className="p-lg">
                                    Rush Studio helps organizations of all sizes manage their translation
                                    projects efficiently. From startups to enterprises, our platform scales
                                    with your needs.
                                </p>
                                {/* List */}
                                <ul className="simple-list">
                                    <li className="list-item">
                                        <p className="p-lg">
                                            Streamlined workflow reduces translation time by up to 60%
                                        </p>
                                    </li>
                                    <li className="list-item">
                                        <p className="p-lg">
                                            Translation memory saves costs on recurring content
                                        </p>
                                    </li>
                                    <li className="list-item">
                                        <p className="p-lg">
                                            Real-time collaboration keeps teams aligned and productive
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* STATISTIC BLOCK */}
                        <div className="col-sm-6 col-lg-3">
                            <div className="statistic-block wow fadeInUp">
                                {/* Icon */}
                                <div className="statistic-ico">
                                    <span className="flaticon-globe" />
                                </div>
                                {/* Text */}
                                <h2 className="h2-lg statistic-number">
                                    <span className="count-element">100</span>+
                                </h2>
                                <p className="p-lg">Languages Supported</p>
                            </div>
                        </div>
                        {/* STATISTIC BLOCK */}
                        <div className="col-sm-6 col-lg-3">
                            <div className="statistic-block wow fadeInUp">
                                {/* Icon */}
                                <div className="statistic-ico">
                                    <span className="flaticon-check" />
                                </div>
                                {/* Text */}
                                <h2 className="h2-lg statistic-number">
                                    <span className="count-element">99.9</span>%
                                </h2>
                                <p className="p-lg">Uptime Guarantee</p>
                            </div>
                        </div>
                    </div>
                    {/* End row */}
                </div>
                {/* End container */}
            </section>
            {/* END STATISTICS */}

            {/* DIVIDER */}
            <hr className="divider" />

            {/* CALL TO ACTION */}
            <section id="cta-5" className="bg-snow cta-section division">
                <div className="container">
                    <div className="cta-5-wrapper bg-whitesmoke">
                        <div className="row d-flex align-items-center">
                            {/* TEXT */}
                            <div className="col-lg-7 col-lg-8">
                                <div className="cta-5-txt">
                                    <h2 className="h2-md">
                                        Ready to Transform Your Translation Workflow?
                                    </h2>
                                    <p className="p-lg">
                                        Join teams worldwide who trust Rush Studio for their translation
                                        management needs. Start your free trial today.
                                    </p>
                                </div>
                            </div>
                            {/* BUTTON */}
                            <div className="col-lg-4 text-end">
                                <div className="cta-5-btn">
                                    <Link to="/" className="btn btn-skyblue tra-grey-hover">
                                        Get Started Free
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* End row */}
                    </div>
                    {/* End cta-5-wrapper */}
                </div>
                {/* End container */}
            </section>
            {/* END CALL TO ACTION */}
        </>
    );
};

export default AboutPage;
